import { Organization } from '@teammood/shared/util/core';
import { OrganizationService } from './organization.service';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { catchError, EMPTY, Subject, takeUntil, tap } from "rxjs";
import { LoggerService } from "@teammood/shared/util/logger";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'organization-create-team',
    templateUrl: 'organization-create-team.component.html',
    providers: [
        OrganizationService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrganizationCreateTeamComponent implements OnInit, OnDestroy {

    protected teamNameCtrl: FormControl<string> = new FormControl<string>('', [Validators.required, Validators.minLength(2)]);

    protected form: FormGroup = new FormGroup({
        teamName: this.teamNameCtrl
    })

    protected organization: Organization & { activeTeamsCount?: number };
    alert = {
        show: false,
        style: undefined,
        message: undefined
    }

    private _destroy$ = new Subject<void>();

    constructor(private logger: LoggerService,
                private organizationService: OrganizationService,
                private route: ActivatedRoute,
                private router: Router,
                ) {
        
    }

    async ngOnInit() {
        await this.init(this.route.snapshot.params['id']);
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    
    private async init(orgId: string){
        
        this.organizationService.get(orgId).pipe(
            tap(org => {
                this.organization = org;
                this.teamNameCtrl.setValue(this.organization.name + " #" + (this.organization.teams.length + 1));
            }),
            catchError(err => {
                this.logger.error(err);
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    async create_new_team() {

        this.organizationService.create_team(this.organization.id, this.teamNameCtrl.value).pipe(
            tap(response => {
                this.alert.style = "alert-success";

                this.alert.message = "Ok !";
                this.alert.show = true;

                setTimeout(async () => {
                    await this.router.navigate(["/setup/teams", response.teamId]);
                }, 2000);
            }),
            catchError(error => {
                this.logger.error(error);

                this.alert.style = "alert-danger";

                this.alert.message = error.data;
                this.alert.show = true;
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

}